import type { Rule } from '../../core/assetType.js';
import type { ValidationIssue } from '../../core/issues.js';
import type { Gameshow } from '../../schemas/gameshow.js';

import { toPointer } from '../../core/issues.js';

/** Gameshows are hosted; the narrator is always named exactly "host". */
export const GAMESHOW_NARRATOR_NAME = 'host';

export const gameshowNarratorName: Rule<Gameshow> = {
  code: 'gameshow.narrator.name',
  check(input): ValidationIssue[] {
    const name = (input as { narratorName?: unknown }).narratorName;
    if (name === GAMESHOW_NARRATOR_NAME) {
      return [];
    }
    const path: (string | number)[] = ['narratorName'];
    return [
      {
        code: 'gameshow.narrator.name',
        severity: 'error',
        message: `Gameshows are hosted; narratorName must be '${GAMESHOW_NARRATOR_NAME}' (found ${
          name === undefined ? 'nothing' : `'${String(name)}'`
        }).`,
        path,
        pointer: toPointer(path),
        currentValue: name,
        constraint: { kind: 'enum', allowedValues: [GAMESHOW_NARRATOR_NAME] },
        fix: {
          kind: 'replace',
          value: GAMESHOW_NARRATOR_NAME,
          rationale: `Set the gameshow narrator name to '${GAMESHOW_NARRATOR_NAME}'`,
        },
      },
    ];
  },
};
